import React from 'react';
import { Link } from 'react-router-dom';
import { Pill } from '../../ui';
import {
    AvatarMini, LienTexte, PersonneCarte, CelluleNom, Muted,
} from '../../security/security.styled';

/* ═══════════════════════════════════════════════════════════════════
   Représentation d'une personne, partagée par les panneaux qui en listent
   d'autres que le titulaire de la fiche : délégations et organisation.

   Deux formes, une seule règle : le portrait s'il existe, les initiales sinon,
   et le nom mène à la fiche du compte dès qu'on connaît son UPN — c'est la clé
   que résout `/Users?user=`.
   ═══════════════════════════════════════════════════════════════════ */

export function initiales(nomComplet) {
    return String(nomComplet || '?')
        .split(/[\s-]+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((mot) => mot[0].toUpperCase())
        .join('');
}

export function Portrait({ personne, taille }) {
    const photo = personne?.profilePicture;
    return (
        <AvatarMini $taille={taille} aria-hidden="true">
            {photo
                ? <img src={`data:image/jpeg;base64,${photo}`} alt="" />
                : initiales(personne?.displayName)}
        </AvatarMini>
    );
}

function lienFiche(upn) {
    return upn ? `/Users?user=${encodeURIComponent(upn)}` : null;
}

// Cellule de tableau : portrait, nom cliquable, et la mention « invité » quand
// elle change la lecture — un compte externe qui détient une délégation sur une
// boîte interne n'est pas un cas ordinaire.
export function CellulePersonne({ personne }) {
    const lien = lienFiche(personne?.userPrincipalName);
    const nom = personne?.displayName || <Muted>Sans nom</Muted>;

    return (
        <CelluleNom>
            <Portrait personne={personne} />
            {lien
                ? (
                    <LienTexte
                        as={Link}
                        to={lien}
                        className="nom"
                        title={`Ouvrir la fiche de ${personne.userPrincipalName}`}
                    >
                        {nom}
                    </LienTexte>
                )
                : <span className="nom">{nom}</span>}
            {personne?.userType === 'Guest' && <Pill $tone="warn">Invité</Pill>}
        </CelluleNom>
    );
}

// Carte : même contenu, mise en page verticale pour l'organigramme. `sous`
// porte ce qui situe la personne — poste, étoile — plutôt que de répéter l'UPN.
export function CartePersonne({ personne, sous, taille = '34px' }) {
    const lien = lienFiche(personne?.userPrincipalName);
    const desactive = personne?.accountEnabled === false;

    return (
        <PersonneCarte
            {...(lien ? { as: Link, to: lien, title: `Ouvrir la fiche de ${personne.userPrincipalName}` } : {})}
        >
            <Portrait personne={personne} taille={taille} />
            <span className="identite">
                <span className="nom">{personne?.displayName || 'Sans nom'}</span>
                <span className="sous">{sous || personne?.jobTitle || personne?.department || '—'}</span>
            </span>
            {desactive && <Pill $tone="danger">Désactivé</Pill>}
        </PersonneCarte>
    );
}
